webpackJsonp([53353647551699],{

/***/ 1403:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Build Your First VR Experience in Just 2 Weeks","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/build-your-first-vr-experience-in-just-two-weeks","createdAt":"2017-07-03T23:37:38.263Z","blogAuthor":{"fields":{"name":"Peter Mosher","slug":"blog/author/peter-mosher"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4ceZnMUR7iOqak0sqccWGa/e389108817d6665f6f5de77163679aa0/blog-post-blog-build-your-first-vr-experience-in-just-two-weeks.jpg"}}}}}]},"authorJson":{"name":"Peter Mosher","slug":"blog/author/peter-mosher","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/peter-mosher"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-peter-mosher-866f25a1da0253663bf1.js